import $ from 'jquery';

export const compassDragRingDirective = ($document) => {
    'ngInject';
    // Start dragging takes two functions, mouseUp is not required
    const startDragging = (onDragFunction, onMouseUpFunction) => {
        $($document).on('mousemove', onDragFunction);
        $($document).one('mouseup', () => {
            if (onMouseUpFunction) {
                onMouseUpFunction();
            }
            $($document).off('mousemove', onDragFunction);
        });
    };

    return {
        restrict: 'A',
        link: (scope, elem) => {
            elem.on('mousedown', (e) => {
                if (e.stopPropagation) {
                    e.stopPropagation();
                }
                if (e.preventDefault) {
                    e.preventDefault();
                }

                scope.$ctrl.startDrag(e, elem);

                startDragging((e) => {
                    scope.$ctrl.dragRing(e, elem);
                }, scope.$ctrl.stopDragging);
            });
        },
    };
};
